module.exports = __webpack_public_path__ + "5ff9c88037fa2c5148a289ca15769f66.svg";